/**
 * Created by qingzhui on 16/12/31.
 */

require('../../scss/m/m-index.scss');

require('../../img/mobile/m-contact-img1.jpg');
require('../../img/mobile/m-contact-img2.jpg');
require('../../img/mobile/m-contact-img3.jpg');
require('../../img/mobile/m-contact-img4.jpg');

require('./m-common');


// WEBPACK FOOTER //
// ./src/m/m-contact.js